

















































import { Component, Vue, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import FinanceiroStore from '../Store/FinanceiroStore'

@Component
export default class ModalItemsRecebimentoErros extends Vue {
  get modalItemsRecebimentoErros() { return this.getFinanceiroStore.modal.itemsRecebimentoErros }
  set modalItemsRecebimentoErros(value: boolean) { this.getFinanceiroStore.setModal({ name: 'itemsRecebimentoErros', value }) }

  get getFinanceiroStore() {
    return getModule(FinanceiroStore, this.$store)
  }

  get itens() {
    return this.getFinanceiroStore.itensRecebimentoErros
  }

  get headers() {
    return [
      { text: 'Código', value: 'codigo', sortable: false, align: 'center' },
      { text: 'Mensagem', value: 'mensagem', sortable: false, align: 'center' },
    ]
  }

  closeModalItemsRecebimentoErros() {
    this.getFinanceiroStore.setModal({ name: 'itemsRecebimentoErros', value: false })
  }
}
